<template>
  <div class="out-wrap">
    <Loadding ref="load" class="load-wrap" :submitInfo="`信息核验中...`" />
    <welcome head_line_title="弘策科技——入职登记表" />
    <div class="input-wrap">
      <van-field class="input" clearable left-icon="contact" v-model="name" label="姓名" placeholder="请输入姓名" />
      <van-field
        class="input"
        type="tel"
        clearable
        left-icon="phone-o"
        v-model="phone"
        label="手机号码"
        placeholder="请输入手机号码"
      />
      <!-- 密码输入框 -->
      <van-field
        class="input"
        v-model="password"
        left-icon="browsing-history-o"
        clearable
        type="password"
        name="密码"
        label="密码"
        placeholder="密码"
        :rules="[{ required: true, message: '请输入校验密码' }]"
      >
        <template #button>
          <van-button size="small" color="#f7c15b" :loading="isLoading" @click="checkPeople('setpassword')"
            >设置密码</van-button
          >
        </template>
      </van-field>
      <van-button
        :disabled="name == '' || phone == ''"
        square
        class="submit-btn"
        style="margin-top: 10px;"
        @click="checkPeople('check')"
        >核验</van-button
      >
      <van-button type="default" v-if="isOk" plain icon="question-o" class="forget-btn" @click="isShowForget = true"
        >忘记密码</van-button
      >

      <van-dialog v-model="isShow" show-cancel-button @confirm="confirmClick">
        <van-form ref="passWord">
          <van-field
            class="input"
            v-model="form.setPassword01"
            clearable
            type="password"
            name="设置密码"
            label="设置密码"
            placeholder="请输入密码"
            :rules="[{ required: true, message: '请输入校验密码' }]"
          />
          <van-field
            class="input"
            v-model="form.setPassword02"
            clearable
            type="password"
            name="确认密码"
            label="确认密码"
            placeholder="请再次确认密码"
            :rules="[{ required: true, message: '请再次确认密码' }]"
          />
        </van-form>
      </van-dialog>

      <van-dialog v-model="isShowForget" show-cancel-button @confirm="confirmPass">
        <van-form ref="forgetPassWord">
          <van-field
            class="input"
            v-model="forgetFrom.interview_id"
            clearable
            type="password"
            name="输入面试邀请码"
            label="面试邀请码"
            placeholder="请输入面试邀请码"
            :rules="[{ required: true, message: '请输入面试邀请码' }]"
          />
          <van-field
            class="input"
            v-model="forgetFrom.newPassword_front"
            clearable
            type="password"
            name="设置密码"
            label="设置密码"
            placeholder="请输入密码"
            :rules="[{ required: true, message: '请输入校验密码' }]"
          />
          <van-field
            class="input"
            v-model="forgetFrom.newPassword_end"
            clearable
            type="password"
            name="确认密码"
            label="确认密码"
            placeholder="请再次确认密码"
            :rules="[{ required: true, message: '请再次确认密码' }]"
          />
        </van-form>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import { request } from '../../utils/request';
import API from '../../utils/API';
import welcome from '../component/welcome';
import Loadding from '../other/comp/load';
import { setStore, getStore, removeStore } from '../../utils/localStore';
export default {
  data() {
    return {
      name: '测试01',
      phone: '13163381883',
      password: '',
      isShow: false,
      isLoading: false,
      isShowForget: false,
      form: {
        setPassword01: '',
        setPassword02: '',
      },
      isOk: false, //是否检测过数据
      staff_id: '',
      interview_id: '',
      forgetFrom: {
        interview_id: '',
        newPassword_front: '',
        newPassword_end: '',
      },
    };
  },
  components: {
    welcome,
    Loadding,
  },
  mounted() {
    if (this.$route.query.type == 'cancel') {
      removeStore({ name: 'joinBaseInfo' });
    }
    //如果是中途退出，再次进入只需输入密码验证即可，之前的信息会保留  仅限2h内
    let originData = getStore({ name: 'joinBaseInfo' });
    if (originData) {
      this.name = originData.name;
      this.phone = oeigin.phone;
      this.jumpToNext(originData.interview_id, originData.staff_id, 'directly');
    }
  },
  methods: {
    confirmPass() {
      this.$refs.forgetPassWord
        .validate()
        .then((res) => {
          if (this.forgetFrom.newPassword_front !== this.forgetFrom.newPassword_end) {
            this.forgetFrom.newPassword_front = this.forgetFrom.newPassword_end = '';
            return this.$toast.fail({ message: `前后密码不一致，请确认！` });
          }
          request({
            method: 'post',
            url: API.FIX_PASSWORD,
            data: {
              interview_id: this.forgetFrom.interview_id,
              password: this.forgetFrom.newPassword_end,
              name: this.name,
              phone: this.phone,
              staff_id: this.staff_id,
            },
          }).then((res) => {
            if (res.defaultMsg) {
              this.$toast.fail({ message: res.defaultMsg.msg });
              this.forgetFrom.interview_id = '';
            } else {
              this.password = this.forgetFrom.newPassword_end;
              this.isOk = false;
              this.$toast.success({ message: '密码修改成功！' });
            }
          });
        })
        .catch((err) => {
          this.$toast.fail({ message: `请${err[0].name}` });
        });
    },
    /* 
    设置密码 且 后面的操作全部为put操作
    */
    confirmClick() {
      this.$refs.passWord
        .validate()
        .then((res) => {
          if (this.form.setPassword01 !== this.form.setPassword02) {
            this.form.setPassword01 = this.form.setPassword02 = '';
            return this.$toast.fail({
              duration: 2500,
              message: `前后密码不一致，请确认！`,
            });
          }
          request({
            method: 'post',
            url: API.POST_JOIN_INFO,
            data: {
              staff_id: this.staff_id,
              password: this.form.setPassword02,
              name: this.name,
              phone: this.phone,
            },
          }).then((res) => {
            let data = res.data;
            if (data.msg === 'success') {
              this.$toast.success({
                duration: 2500,
                message: `密码设置成功`,
              });
              this.password = this.form.setPassword01;
            }
          });
        })
        .catch((err) => {
          this.$toast.fail({
            duration: 2500,
            message: `请${err[0].name}`,
          });
        });
    },
    async getStaffId() {
      await request({
        method: 'get',
        url: API.GET_STAFF_ID,
      })
        .then((res) => {
          let count = Number(res.data.data.count);
          this.staff_id = (count + 1).toString().padStart(4, '0');
        })
        .catch(() => {
          this.$toast.fail({
            duration: 2500,
            message: `系统错误！`,
          });
        });
    },
    checkPeople(type = '') {
      if (!this.name || !this.phone || (type == 'check' && !this.password)) {
        return this.$toast.fail({
          duration: 2500,
          message: `请输入${!this.name ? '姓名' : !this.phone ? '手机号码' : '密码'}`,
        });
      }
      let info = {
        name: this.name,
        phone: this.phone,
        type,
      };
      if (type === 'check') {
        info.password = this.password;
        this.$refs.load.openLoad();
      }
      request({
        method: 'get',
        url: API.CHECK_APPLY_INFO,
        data: info,
      })
        .then((res) => {
          let data = res.data.data;
          this.interview_id = data.data.info.reject_reason.id;
          this.staff_id = (data.data.staff_info && data.data.staff_info.staff_id) || '';
          console.log(data, 'data', this.staff_id);
          //分为两部分  设置密码和校验
          if (type === 'setpassword') {
            //设置密码
            this.$toast.fail({ message: data.resultObj.message });
            if (data.resultObj.status == 'no-password') {
              this.getStaffId();
              setTimeout(() => {
                this.isShow = true;
              }, 2000);
            }
          } else {
            //校验
            if (data.resultObj.status == 'success') {
              setStore({
                name: 'joinBaseInfo',
                content: {
                  interview_id: this.interview_id,
                  staff_id: this.staff_id,
                  name: this.name,
                  phone: this.phone,
                  ability_id: data.data.info.ability_id,
                },
                options: {
                  expiry: '2h',
                },
              });
              this.$toast.success({
                message: data.resultObj.message,
              });
              setTimeout(() => {
                this.jumpToNext(this.interview_id, this.staff_id, 'request');
              }, 2000);
            } else {
              this.$toast.fail({ message: data.resultObj.message });
              setTimeout(() => {
                this.isOk = true;
              }, 2000);
            }
            this.$refs.load.closeLoad();
          }
        })
        .catch(() => {
          this.$toast.fail('系统错误!');
          this.$refs.load.closeLoad();
        });
    },
    jumpToNext(id, staff_id, type) {
      this.$router.push({
        path: '/induction_value',
        query: {
          id,
          staff_id,
          type,
          page: 'base',
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/page.css';
@import '../../assets/css/wrap.css';
.forget-btn {
  margin: 10px 0 0 0;
}
</style>
